import React from 'react';

import DialogActions from '@mui/material/DialogActions';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';

import { Button } from 'components/Button';

function CustomActionBar({ actions, onAccept }: PickersActionBarProps & { onAccept?: () => void }): React.ReactElement {
  const handleAccept = onAccept || (actions?.includes('accept') ? () => {} : undefined);

  return (
    <DialogActions
      style={{
        gridColumn: '1/4',
        gridRow: '4',
        padding: '0',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <Button onClick={handleAccept} size="large">
        OK
      </Button>
    </DialogActions>
  );
}

export default CustomActionBar;
